<template>
  <div>
    <div class="title font-weight-medium primaryText--text" style="white-space: pre-wrap;">{{ title }}</div>
    <div class="body-2 mt-1 primaryText--text" v-if="hasSubtitle">{{ subtitle }}</div>
  </div>
</template>


<script>
export default {
  name: "HeaderTitle",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    }
  },
  computed: {
      hasSubtitle(){
          return this.subtitle && this.subtitle.length;
      }
  }
};
</script>


